var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1017",
    "data-name": "Frame 1017",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1017_Background_Mask_",
    "data-name": "Frame 1017 (Background/Mask)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#e6e8ec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_File_Upload_Line",
    "data-name": "icons/File Upload/Line",
    transform: "translate(14.258 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.984,16H4.5A4.008,4.008,0,0,1,.508,12.25l-.5-8A4,4,0,0,1,4,0H15.484a4,4,0,0,1,3.992,4.25l-.5,8A4.007,4.007,0,0,1,14.984,16ZM4,2A2,2,0,0,0,2,4.125l.5,8A2,2,0,0,0,4.5,14H14.984a2,2,0,0,0,2-1.876l.5-8a2,2,0,0,0-2-2.125Z",
    transform: "translate(0 4)",
    fill: "#777e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5,0a5,5,0,0,1,5,5V7A1,1,0,0,1,8,7V5A3,3,0,0,0,2,5V7A1,1,0,0,1,0,7V5A5,5,0,0,1,5,0Z",
    transform: "translate(4.742)",
    fill: "#777e90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.64617d22005402de3e5a0cd550d2a53d.svg";
export { ForwardRef as ReactComponent };